import { ModalCustom } from "components/ModalCustom";
import { FaExclamation } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ExcluirLoteSchema } from "../../../../../validate/excluirLoteSchema";
import {
  ErroTexto,
  IconeCirculo,
  ObservacaoContainer,
  TextoDescricao,
  TituloComIcone,
} from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: (observacao: string) => void;
}

export function ModalExcluirLote({ show, handleClose, onConfirm }: IProps) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ExcluirLoteSchema),
  });

  useEffect(() => {
    if (show) reset();
  }, [show]);

  const onSubmit = async (dados: { observacao: string }) => {
    await onConfirm(dados.observacao);
    reset();
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={
        <TituloComIcone>
          <IconeCirculo>
            <FaExclamation />
          </IconeCirculo>
          Remover lote
        </TituloComIcone>
      }
      centered
      footer
      footerConfirmButton
      onConfirm={handleSubmit(onSubmit)}
      confirmButtonText="Remover"
    >
      <TextoDescricao>Deseja remover o lote selecionado?</TextoDescricao>
      <ObservacaoContainer>
        <Form.Group>
          <Form.Label>
            Observação <span style={{ color: "#ee5353" }}>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Informe o motivo da remoção"
            {...register("observacao")}
            isInvalid={!!errors.observacao}
          />
          {errors.observacao && <ErroTexto>{errors.observacao.message as string}</ErroTexto>}
        </Form.Group>
      </ObservacaoContainer>
    </ModalCustom>
  );
}
